import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Currency from "../../_common/Currency/index"
import NRTButton from "../../_common/_buttons/Button"
import ButtonWithChevron from "../../_minha-central/ButtonWithChevron"


const CourseSignIn = (props) => {

    const {sightValue,
        maxInstallments,
        installmentValue,
        onClick,
        soldOut,
    } = props;

    return (
        <div className='course-signin-box'>

            <h4>
                Inscreva-se
            </h4>

            <div className='price'>
                {
                    sightValue === 0 ? (


                                <div style={{marginBottom:'1rem'}}>Grátis</div>
                    ) :
                        (
                            <React.Fragment>
                                <Currency value={sightValue}/>
                                {
                                    !!maxInstallments &&
                                    <p className='payment-options'>
                                        ou {maxInstallments}x de <Currency value={installmentValue}/>
                                    </p>
                                }
                            </React.Fragment>
                        )

                }

                {
                    maxInstallments === 0 &&
                        <div style={{marginBottom:'2rem'}}/>
                }

            </div>

            {
                soldOut ?
                    <h5 style={{fontSize:'1.3rem'}}>Vagas esgotadas</h5> :
                    <ButtonWithChevron
                        buttonLabel={'INSCREVA-SE JÁ'}
                        actionButton
                        onClick={onClick}
                    />
            }



        </div>
    )
}

CourseSignIn.propTypes = {
    sightValue: PropTypes.number.isRequired,
    maxInstallments: PropTypes.number.isRequired,
    installmentValue: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired ,
    soldOut: PropTypes.bool ,
}

export default CourseSignIn



// WEBPACK FOOTER //
// ./src/components/_courses/CourseSignIn/CourseSignIn.js